'use strict'

import GoogleMap from "../utils/GoogleMap";
import Form from "../utils/Form";

class Dealers {
    constructor(){
		var self=this;
		
		$('.menu.desktop.r .menu_dealers').addClass('active');

		new Form().done((data) => {
			if(data.status==200){
				var str=location.pathname;
				if (str.charAt(str.length - 1) !== '/') {
					str = str + '/';
				}
				location.href = location.origin + str + 'completado/' + location.search;
			}
        });
		
		if ($(window).width() > 768) {
			$('#map').css({'width' : '100%', 'height' : '100%'});

			google.maps.event.addDomListener(window, 'load', function(){
				var map = new google.maps.Map(document.getElementById('map'), {
					zoom: 13,
					center: new google.maps.LatLng(18.2388, -66.035249),
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					disableDefaultUI: true,
					zoomControl: true,
					scaleControl: true,
					scrollwheel: true,
				});
				var marker, i;
				var bounds = new google.maps.LatLngBounds();
				var activeInfoWindow;
				var smallIcon = {
					url: App.baseUrl + '/img/map-mark-small.svg',
					anchor: new google.maps.Point(9,9),
					scaledSize: new google.maps.Size(18,18)
				};
				$('.dealerList li').each(function () {
					var i=$(this).index()+1;
					marker = new google.maps.Marker({
						'position'	: new google.maps.LatLng(Number($(this).data().latitude), Number($(this).data().longitude)),
						'map'		: map,
						'icon'		: smallIcon,
						'infoWindow': true,
					});
					const infowindow = new google.maps.InfoWindow({
					   content: `<div class="map-tooltip"><p>${$(this).data().name}</p><p>${$(this).data().address}</p><p>${$(this).data().location}</p></div>`,
					});

					google.maps.event.addListener(marker, 'click', (function (marker, i) {
						return function () {
							if (activeInfoWindow) { activeInfoWindow.close();}
							infowindow.open(map, marker);
							activeInfoWindow = infowindow;
						}
					})(marker, i));

					bounds.extend(marker.getPosition());
				});
				map.fitBounds(bounds);

				var bigMarker=false;
				var icon = {
					url: App.baseUrl + '/img/map-mark.svg',
					anchor: new google.maps.Point(30,30),
					scaledSize: new google.maps.Size(60,60)
				};
				$('.dealerList li').on('map', function () {
					if (activeInfoWindow) { activeInfoWindow.close();}
					if(bigMarker){
						bigMarker.setMap(null);
					}
					bigMarker = new google.maps.Marker({
						'position'	: new google.maps.LatLng(Number($(this).data().latitude), Number($(this).data().longitude)),
						'map'		: map,
						'icon'		: icon,
					});
					const infowindow = new google.maps.InfoWindow({
					   content: `<div class="map-tooltip"><p>${$(this).data().name}</p><p>${$(this).data().address}</p><p>${$(this).data().location}</p></div>`,
					});

					google.maps.event.addListener(bigMarker, 'click', (function (bigMarker, i) {
						return function () {
							if (activeInfoWindow) { activeInfoWindow.close();}
							infowindow.open(map, bigMarker);
							activeInfoWindow = infowindow;
						}
					})(bigMarker, i));

					map.setCenter(new google.maps.LatLng(Number($(this).data().latitude), Number($(this).data().longitude)) );
					map.setZoom(15);
				});

			});
		}else{
			self.maps_mobile={};
			var marker;
			google.maps.event.addDomListener(window, 'load', function(){
				$('.map.mobile').each(function(){
					var self_map=$(this).find('div');
					self_map.css({'width' : '100%', 'height' : '100%'});

					self.maps_mobile[self_map.attr('id')] = new google.maps.Map(document.getElementById(self_map.attr('id')), {
						zoom: 13,
						center: new google.maps.LatLng(Number(self_map.closest('li').data().latitude), Number(self_map.closest('li').data().longitude)),
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						disableDefaultUI: true,
						zoomControl: true,
						scaleControl: true,
						scrollwheel: true,
					});
					var icon = {
						url: App.baseUrl + '/img/map-mark.svg',
						anchor: new google.maps.Point(30,30),
						scaledSize: new google.maps.Size(60,60)
					};
					marker = new google.maps.Marker({
						'position'	: new google.maps.LatLng(Number(self_map.closest('li').data().latitude), Number(self_map.closest('li').data().longitude)),
						'map'		: self.maps_mobile[self_map.attr('id')],
						'icon'		: icon,
						'infoWindow': true,
					});

				});

			});
		}
		
        
        $('.showContact').on('click', function(e) {
            e.preventDefault();
            $('.dealerForm').fadeIn();
            $(this).addClass('active');
            var section = $(this).closest('section');
            //if($(section).hasClass('dealershipDetail')) {
            //    $('.dealerList').hide();
            //};
        })
    
        $('.dealerList li').on('click', function() {
        	var active = $(this).hasClass('active');
            $('.dealerList li').removeClass('active');
            if (active) $(this).removeClass('active');
            else $(this).addClass('active');

			if ($(window).width() > 768) {
				$('#dealer').val($(this).data().id).selectric('refresh');
				$(this).trigger('map');
			}else{
				$('.dealerList li .opts').hide();
				$('.dealerList li .more').hide();
				$('.dealerList li .moreDealer').hide();
				if (active) {
					$(this).find('.opts').hide();
					$(this).find('.more').hide();
				} else {
					$(this).find('.opts').show();
					$(this).find('.more').show();
				}
			}
            
        })
    
        $('.dealerForm').on('click', function() {
            $(this).fadeOut();
            $('.showContact').removeClass('active');
        })
        $('.dealerForm form').on('click', function(e) {
            e.stopPropagation();
        })
    }
}

export default Dealers;